export default __webpack_public_path__ + "assets/warning.0a2bf3f6.svg";